import { Link } from "react-router-dom";
import { events } from "@/mocks/events";

export default function UpdateTimeline() {
  const sorted = [...events].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 5);

  return (
    <section id="timeline" className="w-full bg-foreground-950 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.6fr] lg:gap-14">
          <div>
            <p className="inline-flex items-center gap-2 rounded-full border border-background-50/20 bg-background-50/10 px-3 py-1 font-label text-xs tracking-wide text-accent-300">
              <i className="ri-history-line" aria-hidden="true"></i>
              更新节奏
            </p>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
              档案不是一次写完的
            </h2>
            <p className="mt-5 font-body text-sm leading-relaxed text-background-300 md:text-base">
              一个事件在公开层面往往会经历多个节点：先是信息出现，然后是相关方说明，最后热度回落。
              我们会在每个节点之后更新档案，并在页面上标注最后修改时间，让后来的人也能看到完整过程。
            </p>
            <div className="mt-7 flex flex-col gap-3 border-l border-background-50/15 pl-5">
              {[
                { icon: "ri-radar-line", text: "信息出现，建立临时档案" },
                { icon: "ri-link", text: "核对公开来源，补齐时间线" },
                { icon: "ri-checkbox-circle-line", text: "相关方回应，更新事件状态" },
                { icon: "ri-inbox-archive-line", text: "无新进展，转入归档" },
              ].map((step) => (
                <div key={step.text} className="flex items-center gap-3">
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-background-50/10 text-accent-300">
                    <i className={step.icon} aria-hidden="true"></i>
                  </span>
                  <span className="font-body text-sm text-background-200">{step.text}</span>
                </div>
              ))}
            </div>
          </div>

          <ol className="relative flex flex-col gap-6 border-l border-background-50/15 pl-6">
            {sorted.map((item) => {
              const last = item.timeline[item.timeline.length - 1];
              return (
                <li key={item.id} className="relative">
                  <span className="absolute -left-[31px] top-1.5 flex h-3 w-3 items-center justify-center rounded-full bg-accent-400"></span>
                  <Link to={`/topic/${item.id}`} className="group block">
                    <div className="flex flex-wrap items-center gap-3">
                      <span className="rounded-md bg-background-50/10 px-2.5 py-0.5 font-label text-xs text-accent-300">
                        {item.date}
                      </span>
                      <span className="font-label text-xs text-background-400">{item.categoryName}</span>
                      <span className="font-label text-xs text-background-400">· {item.status}</span>
                    </div>
                    <h3 className="mt-2 font-heading text-base font-bold text-background-50 transition-colors group-hover:text-accent-300 md:text-lg">
                      {item.title}
                    </h3>
                    <p className="mt-1.5 font-body text-sm leading-relaxed text-background-300">
                      最新节点 · {last.title}：{last.content}
                    </p>
                  </Link>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}